import React, { type JSX } from 'react';
import { useRouteMatch, useHistory, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import './styles/index.scss';
import Logo from '../Loading/Logo';
import { SVGIcon } from 'magical-trails-react';
import { RootState } from '../../store';

const Home: React.FC = (): JSX.Element => {
  let { path } = useRouteMatch();
  let history = useHistory();
  const apiError = useSelector((state: RootState) => state.trail.apiError);

  return (
    <div className="start-screen flex h-screen flex-col items-center justify-center gap-6 bg-cover bg-center bg-no-repeat">
      {!!apiError && (
        <div
          role="alert"
          className="text-mt-danger w-64 rounded-xl bg-white/95 px-4 py-3 text-center text-sm shadow-lg"
        >
          We couldn&apos;t find that code. Please check it and scan or type it
          again.
        </div>
      )}
      <div className="bg-mt-surface flex w-64 flex-col gap-4 rounded-2xl p-6 shadow-2xl">
        <Logo className="mx-auto my-20" baseSize={4.25} />

        <h1 className="text-mt-ink-soft mb-2 text-xl font-bold tracking-tight">
          Welcome to
          <br />
          <span className="text-3xl">Magical Trails</span>
        </h1>
        <Link
          className="mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary inline-flex items-center gap-x-2 rounded-md px-3.5 py-2.5 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2"
          to="/scan"
        >
          <SVGIcon icon="qr-code" className="-mr-0.5 h-5 w-5" />
          Scan QR Code
        </Link>
        <Link
          className="mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary inline-flex items-center gap-x-2 rounded-md px-3.5 py-2.5 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2"
          to="/enter-code"
        >
          <SVGIcon icon="code" className="-mr-0.5 h-5 w-5" />
          Type in Code
        </Link>
        <p className="text-mt-ink-muted text-center text-xs">
          Want to run your own trail?{' '}
          <a
            href="https://magicaltrails.com/?utm_source=player&utm_medium=start-screen"
            target="_blank"
            rel="noopener"
            className="text-mt-primary font-semibold underline"
          >
            magicaltrails.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default Home;
